import type { IUser, PostDocument } from 'garden-common';
import { api } from './index'
import { handleAxiosError } from './error-handler.util';

export const createDonation = async (postId: PostDocument['_id'], seed: number) => {
  return await api
    .post(`/v2/donation/create/${postId}`, {
      eventType: 'Garden Sale',
      transactionAmount: seed
    })
    .then(res => {
      return res.data?.Donation;
    })
    .catch(handleAxiosError);
};

export const getDonationsReceivedByUser = async (id: string, sort: any) => {
  return await api
    .get(`/v2/donation/user/${id}/donationsReceived`, {
      params: {
        sortKey: sort
      }
    })
    .then(res => {
      return res.data?.donations;
    })
    .catch(handleAxiosError);
};

export const getDonationsItemsByUser = async (options: {
  id: IUser<string>['_id'];
  page: number;
  limit: number;
}) => {
  return await api
    .get(`/v2/donation/user/${options.id}/posts/donated`, {
      params: { limit: options.limit ?? 20, page: options.page ?? 1 }
    })
    .then(res => {
      return res.data?.donationsToPosts;
    })
    .catch(handleAxiosError);
};

export const getPostDonations = async (sort: any, id: string) => {
  return await api
    .get(`/v2/donation/post/${id}?sortKey=${JSON.stringify(sort)}`)
    .then(res => {
      return res.data?.donations;
    })
    .catch(handleAxiosError);
};

export const getUserDonation = async (id: string) => {
  return await api
    .get(`/v2/donation/user/${id}`)
    .then(res => {
      return res.data?.donations;
    })
    .catch(handleAxiosError);
};

export const getDonationsItemsByUserByItem = async (userId: string, itemId: string) => {
  return await api
    .get(`/v2/donation/user/${userId}/item/${itemId}`)
    .then(res => {
      return res.data?.donations;
    })
    .catch(handleAxiosError);
};

export const getDonationDetails = async (donationId: string) => {
  return await api
    .get(`/v2/donation/${donationId}`)
    .then(res => {
      return res.data?.donation;
    })
    .catch(handleAxiosError);
};
